import getLodop from '@/utils/lodop'
import {Message} from 'element-ui'

//快速验收
const fastCheck = (product, LODOP) => {
	LODOP.ADD_PRINT_BARCODE("10", "10", "256", "50", product.barcodeStyle, product.skuValue);//条码
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1)
	LODOP.ADD_PRINT_TEXT("60", "10", "80", "17", 'P.N:' + product.storageLocation);//库位
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1)
	LODOP.ADD_PRINT_TEXT("60", "104", "60", "17", 'Q.I:' + product.checkAdminId);//质检人员ID
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1)
	LODOP.ADD_PRINT_TEXT("60", "175", "60", "17", 'Buy:' + product.purAdminId);//采购人员ID
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1)
	LODOP.ADD_PRINT_TEXT("79", "10", "256", "20", product.skuName);//SKU
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1)
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
	if (product.alibabaOrderCode) {
		LODOP.ADD_PRINT_TEXT("97", "10", "200", "20", 'SNo:' + product.alibabaOrderCode);//1688订单编号
		LODOP.SET_PRINT_STYLEA(0, "Bold", 1)
	}
	LODOP.ADD_PRINT_IMAGE(10, 258, 100, 100, product.goodsThumbBase64);//SKU缩略图
	LODOP.SET_PRINT_STYLEA(0, "Stretch", 1)
}

//sku泰国
const skuTH = (product, LODOP) => {
	LODOP.ADD_PRINT_TEXT(11, 4, 50, 21, "P.N:" + product.storageLocation);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
	LODOP.ADD_PRINT_TEXT(11, 61, 40, 20, "Q.I:" + product.checkAdminId);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
	LODOP.ADD_PRINT_TEXT(11, 108, 40, 20, "Buy:" + product.purAdminId);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
	LODOP.ADD_PRINT_TEXT(33, 16, 120, 25, product.skuName);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
	LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
	LODOP.ADD_PRINT_BARCODE(61, 20, 140, 46, product.barcodeStyle, product.skuValue);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
	LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Full-Page");

}
//sku美国
const skuUSA = (product, LODOP) => {
	LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE", 1);
	LODOP.ADD_PRINT_TEXT(106, 400, 168, 36, product.skuValue);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 27);
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
	LODOP.ADD_PRINT_BARCODE(95, 22, 350, 70, product.barcodeStyle, product.barcode);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
	let goodsName = product.goodsName;
	if (goodsName.length > 20) {
		goodsName = goodsName.substring(0, 20) + ".....";
	}
	LODOP.ADD_PRINT_TEXT(4, 3, 503, 45, goodsName);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 25);
	LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
	LODOP.ADD_PRINT_TEXT(46, 1, 506, 37, product.skuName);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 20);
	LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
	LODOP.ADD_PRINT_TEXT(170, 270, 140, 15, "Made  in  China ");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
	LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
	LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Full-Page");

}

//退货入库泰国
const returnSkuTH = (product, LODOP) => {
	LODOP.ADD_PRINT_TEXT(11, 16, 60, 20, "P.N:" + product.storageLocation);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
	LODOP.ADD_PRINT_TEXT(11, 75, 60, 20, "Q.I:" + product.checkAdminId);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
	LODOP.ADD_PRINT_TEXT(33, 12, 120, 25, product.skuName);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
	LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
	LODOP.ADD_PRINT_BARCODE(61, 2, 140, 46, product.barcodeStyle, product.skuValue);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
}

//到货异常
const deliveryExp = (product, LODOP) => {
	LODOP.ADD_PRINT_TEXT(5, 2, 37, 15, "异常件");
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
	LODOP.ADD_PRINT_TEXT(4, 50, 40, 15, "Q.I:" + product.checkAdminId);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
	LODOP.ADD_PRINT_TEXT(16, 2, 145, 28, "异常原因:" + product.reasonMessage);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
	LODOP.ADD_PRINT_TEXT(47, 16, 120, 15, product.skuName);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
	LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

	let barcode = product.skuValue
	if ("UPC_A" === product.barcodeStyle) {
		barcode = product.barcode
	}
	LODOP.ADD_PRINT_BARCODE(61, 2, 140, 46, product.barcodeStyle, barcode);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
	LODOP.ADD_PRINT_TEXT(4, 100, 50, 15, "Buy:" + product.purAdminId);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
	LODOP.ADD_PRINT_TEXT(35, 2, 100, 15, "SNo:" + product.alibabaOrderCode1);
	LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
	LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
}

const printSku = (product, name, params) => {
	const LODOP = getLodop()
	LODOP.PRINT_INITA(5, 9, 510, 170, "");
	LODOP.SET_PRINT_PAGESIZE(0, 450, 150, "CreateCustomPage");
	//让外部传入的单商品也以数组方式处理
	let products = [];
	if (Array.isArray(product)) {
		products = product;
	} else {
		products.push(product);
	}

	//1001,快速验收
	//1, 到货异常
	//2, 退货入库
	//sku条码

	//校验
	for (let i = 0; i < products.length; i++) {
		let product = products[i];
		switch (params.type) {
			case 1001:
				if (!product.goodsThumbBase64) {
					Message.error("SKU:[" + product.skuValue + ']商品图片加载异常,无法打印条码,请重新尝试')
					return;
				}
				break;
			case 1:
				if (!product.alibabaOrderCode) {
					Message.error('1688单号不能为空');
					return;
				}
				break;
			default:
				break;
		}
	}

	//打印
	for (let i = 0; i < products.length; i++) {
		console.log("商品, i=" + i);
		newPage(products[i], params.type, LODOP);
	}

	let mode = window.lodopMode;
	console.log("开始调用LODOP打印，当前模式:mode" + mode);
	if (!mode) {
		console.log("PRINT模式");
		LODOP.PRINT()
		console.log("PRINT模式完成");
	} else if (mode === 1) {
		console.log("PREVIEW模式");
		//预览模式
		LODOP.PREVIEW()
		console.log("PREVIEW模式完成");
	} else if (mode === 2) {
		//设计模式
		console.log("PRINT_DESIGN模式");
		LODOP.PRINT_DESIGN()
		console.log("PRINT_DESIGN模式完成");

	}
}

const newPage = (product, type, LODOP) => {
	LODOP.NewPage();
	//如果有条形码且条形码为12位，则使用UPC_A条码模式
	let barcodeStyle = "128A"
	if (product.barcode && product.barcode.length === 12) {
		barcodeStyle = "UPC_A"
	}
	product.barcodeStyle = barcodeStyle;
	switch (type) {
		case 1001:
			fastCheck(product, LODOP)
			break;
		case 1:
			deliveryExp()
			break;
		case 2:
			if ("UPC_A" === barcodeStyle) {
				skuUSA(product, LODOP)
			} else {
				returnSkuTH(product, LODOP)
			}
			break;
		default:
			if ("UPC_A" === barcodeStyle) {
				skuUSA(product, LODOP)
			} else {
				skuTH(product, LODOP);
			}
			break;
	}
}

export default printSku



// WEBPACK FOOTER //
// ./src/utils/printTemp/skuPrintTemplate.js